import script from "./ClubEventTeamSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubEventTeamSetup.vue?vue&type=script&setup=true&lang=js"

import "./ClubEventTeamSetup.vue?vue&type=style&index=0&id=7502864a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7502864a"]])

export default __exports__